const $pickSchoolEl = $('#pickSchoolSelect');

$pickSchoolEl.selectize({
  onChange: link => window.location.href = link
});
